require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("clojure.set.js");
goog.provide('clojure.set');

clojure.set.bubble_max_key = function clojure$set$bubble_max_key(k, coll) {
  var max = cljs.core.apply.cljs$core$IFn$_invoke$arity$3(cljs.core.max_key, k, coll);
  return cljs.core.cons(max, cljs.core.remove.cljs$core$IFn$_invoke$arity$2(function (p1__24933_SHARP_) {
    return max === p1__24933_SHARP_;
  }, coll));
};
/**
 * Return a set that is the union of the input sets
 */


clojure.set.union = function clojure$set$union(var_args) {
  var G__24938 = arguments.length;

  switch (G__24938) {
    case 0:
      return clojure.set.union.cljs$core$IFn$_invoke$arity$0();
      break;

    case 1:
      return clojure.set.union.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return clojure.set.union.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___24977 = arguments.length;
      var i__4737__auto___24978 = 0;

      while (true) {
        if (i__4737__auto___24978 < len__4736__auto___24977) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___24978]);
          var G__24980 = i__4737__auto___24978 + 1;
          i__4737__auto___24978 = G__24980;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return clojure.set.union.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

clojure.set.union.cljs$core$IFn$_invoke$arity$0 = function () {
  return cljs.core.PersistentHashSet.EMPTY;
};

clojure.set.union.cljs$core$IFn$_invoke$arity$1 = function (s1) {
  return s1;
};

clojure.set.union.cljs$core$IFn$_invoke$arity$2 = function (s1, s2) {
  if (cljs.core.count(s1) < cljs.core.count(s2)) {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core.conj, s2, s1);
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core.conj, s1, s2);
  }
};

clojure.set.union.cljs$core$IFn$_invoke$arity$variadic = function (s1, s2, sets) {
  var bubbled_sets = clojure.set.bubble_max_key(cljs.core.count, cljs.core.conj.cljs$core$IFn$_invoke$arity$variadic(sets, s2, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([s1], 0)));
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core.into, cljs.core.first(bubbled_sets), cljs.core.rest(bubbled_sets));
};
/** @this {Function} */


clojure.set.union.cljs$lang$applyTo = function (seq24935) {
  var G__24936 = cljs.core.first(seq24935);
  var seq24935__$1 = cljs.core.next(seq24935);
  var G__24937 = cljs.core.first(seq24935__$1);
  var seq24935__$2 = cljs.core.next(seq24935__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__24936, G__24937, seq24935__$2);
};

clojure.set.union.cljs$lang$maxFixedArity = 2;
/**
 * Return a set that is the intersection of the input sets
 */

clojure.set.intersection = function clojure$set$intersection(var_args) {
  var G__24944 = arguments.length;

  switch (G__24944) {
    case 1:
      return clojure.set.intersection.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return clojure.set.intersection.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___24983 = arguments.length;
      var i__4737__auto___24984 = 0;

      while (true) {
        if (i__4737__auto___24984 < len__4736__auto___24983) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___24984]);
          var G__24985 = i__4737__auto___24984 + 1;
          i__4737__auto___24984 = G__24985;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return clojure.set.intersection.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

clojure.set.intersection.cljs$core$IFn$_invoke$arity$1 = function (s1) {
  return s1;
};

clojure.set.intersection.cljs$core$IFn$_invoke$arity$2 = function (s1, s2) {
  while (true) {
    if (cljs.core.count(s2) < cljs.core.count(s1)) {
      var G__24986 = s2;
      var G__24987 = s1;
      s1 = G__24986;
      s2 = G__24987;
      continue;
    } else {
      return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (s1, s2) {
        return function (result, item) {
          if (cljs.core.contains_QMARK_(s2, item)) {
            return result;
          } else {
            return cljs.core.disj.cljs$core$IFn$_invoke$arity$2(result, item);
          }
        };
      }(s1, s2), s1, s1);
    }

    break;
  }
};

clojure.set.intersection.cljs$core$IFn$_invoke$arity$variadic = function (s1, s2, sets) {
  var bubbled_sets = clojure.set.bubble_max_key(function (p1__24939_SHARP_) {
    return -cljs.core.count(p1__24939_SHARP_);
  }, cljs.core.conj.cljs$core$IFn$_invoke$arity$variadic(sets, s2, cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([s1], 0)));
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(clojure.set.intersection, cljs.core.first(bubbled_sets), cljs.core.rest(bubbled_sets));
};
/** @this {Function} */


clojure.set.intersection.cljs$lang$applyTo = function (seq24941) {
  var G__24942 = cljs.core.first(seq24941);
  var seq24941__$1 = cljs.core.next(seq24941);
  var G__24943 = cljs.core.first(seq24941__$1);
  var seq24941__$2 = cljs.core.next(seq24941__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__24942, G__24943, seq24941__$2);
};

clojure.set.intersection.cljs$lang$maxFixedArity = 2;
/**
 * Return a set that is the first set without elements of the remaining sets
 */

clojure.set.difference = function clojure$set$difference(var_args) {
  var G__24949 = arguments.length;

  switch (G__24949) {
    case 1:
      return clojure.set.difference.cljs$core$IFn$_invoke$arity$1(arguments[0]);
      break;

    case 2:
      return clojure.set.difference.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    default:
      var args_arr__4757__auto__ = [];
      var len__4736__auto___24990 = arguments.length;
      var i__4737__auto___24994 = 0;

      while (true) {
        if (i__4737__auto___24994 < len__4736__auto___24990) {
          args_arr__4757__auto__.push(arguments[i__4737__auto___24994]);
          var G__24995 = i__4737__auto___24994 + 1;
          i__4737__auto___24994 = G__24995;
          continue;
        } else {}

        break;
      }

      var argseq__4758__auto__ = new cljs.core.IndexedSeq(args_arr__4757__auto__.slice(2), 0, null);
      return clojure.set.difference.cljs$core$IFn$_invoke$arity$variadic(arguments[0], arguments[1], argseq__4758__auto__);
  }
};

clojure.set.difference.cljs$core$IFn$_invoke$arity$1 = function (s1) {
  return s1;
};

clojure.set.difference.cljs$core$IFn$_invoke$arity$2 = function (s1, s2) {
  if (cljs.core.count(s1) < cljs.core.count(s2)) {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (result, item) {
      if (cljs.core.contains_QMARK_(s2, item)) {
        return cljs.core.disj.cljs$core$IFn$_invoke$arity$2(result, item);
      } else {
        return result;
      }
    }, s1, s1);
  } else {
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(cljs.core.disj, s1, s2);
  }
};

clojure.set.difference.cljs$core$IFn$_invoke$arity$variadic = function (s1, s2, sets) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(clojure.set.difference, s1, cljs.core.conj.cljs$core$IFn$_invoke$arity$2(sets, s2));
};
/** @this {Function} */


clojure.set.difference.cljs$lang$applyTo = function (seq24946) {
  var G__24947 = cljs.core.first(seq24946);
  var seq24946__$1 = cljs.core.next(seq24946);
  var G__24948 = cljs.core.first(seq24946__$1);
  var seq24946__$2 = cljs.core.next(seq24946__$1);
  var self__4723__auto__ = this;
  return self__4723__auto__.cljs$core$IFn$_invoke$arity$variadic(G__24947, G__24948, seq24946__$2);
};

clojure.set.difference.cljs$lang$maxFixedArity = 2;
/**
 * Returns a set of the elements for which pred is true
 */

clojure.set.select = function clojure$set$select(pred, xset) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (s, k) {
    if (cljs.core.truth_(pred.cljs$core$IFn$_invoke$arity$1 ? pred.cljs$core$IFn$_invoke$arity$1(k) : pred.call(null, k))) {
      return s;
    } else {
      return cljs.core.disj.cljs$core$IFn$_invoke$arity$2(s, k);
    }
  }, xset, xset);
};
/**
 * Returns a rel of the elements of xrel with only the keys in ks
 */


clojure.set.project = function clojure$set$project(xrel, ks) {
  return cljs.core.set(cljs.core.map.cljs$core$IFn$_invoke$arity$2(function (p1__24950_SHARP_) {
    return cljs.core.select_keys(p1__24950_SHARP_, ks);
  }, xrel));
};
/**
 * Returns the map with the keys in kmap renamed to the vals in kmap
 */


clojure.set.rename_keys = function clojure$set$rename_keys(map, kmap) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (m, p__24951) {
    var vec__24952 = p__24951;
    var old = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24952, 0, null);
    var new$ = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24952, 1, null);

    if (cljs.core.contains_QMARK_(map, old)) {
      return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, new$, cljs.core.get.cljs$core$IFn$_invoke$arity$2(map, old));
    } else {
      return m;
    }
  }, cljs.core.apply.cljs$core$IFn$_invoke$arity$3(cljs.core.dissoc, map, cljs.core.keys(kmap)), kmap);
};
/**
 * Returns a rel of the maps in xrel with the keys in kmap renamed to the vals in kmap
 */


clojure.set.rename = function clojure$set$rename(xrel, kmap) {
  return cljs.core.set(cljs.core.map.cljs$core$IFn$_invoke$arity$2(function (p1__24955_SHARP_) {
    return clojure.set.rename_keys(p1__24955_SHARP_, kmap);
  }, xrel));
};
/**
 * Returns a map of the distinct values of ks in the xrel mapped to a
 *   set of the maps in xrel with the corresponding values of ks.
 */


clojure.set.index = function clojure$set$index(xrel, ks) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (m, x) {
    var ik = cljs.core.select_keys(x, ks);
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m, ik, cljs.core.conj.cljs$core$IFn$_invoke$arity$2(cljs.core.get.cljs$core$IFn$_invoke$arity$3(m, ik, cljs.core.PersistentHashSet.EMPTY), x));
  }, cljs.core.PersistentArrayMap.EMPTY, xrel);
};
/**
 * Returns the map with the vals mapped to the keys.
 */


clojure.set.map_invert = function clojure$set$map_invert(m) {
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (m__$1, p__24956) {
    var vec__24957 = p__24956;
    var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24957, 0, null);
    var v = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24957, 1, null);
    return cljs.core.assoc.cljs$core$IFn$_invoke$arity$3(m__$1, v, k);
  }, cljs.core.PersistentArrayMap.EMPTY, m);
};
/**
 * When passed 2 rels, returns the rel corresponding to the natural
 *   join. When passed an additional keymap, joins on the corresponding
 *   keys.
 */


clojure.set.join = function clojure$set$join(var_args) {
  var G__24965 = arguments.length;

  switch (G__24965) {
    case 2:
      return clojure.set.join.cljs$core$IFn$_invoke$arity$2(arguments[0], arguments[1]);
      break;

    case 3:
      return clojure.set.join.cljs$core$IFn$_invoke$arity$3(arguments[0], arguments[1], arguments[2]);
      break;

    default:
      throw new Error(["Invalid arity: ", cljs.core.str.cljs$core$IFn$_invoke$arity$1(arguments.length)].join(''));
  }
};

clojure.set.join.cljs$core$IFn$_invoke$arity$2 = function (xrel, yrel) {
  if (cljs.core.seq(xrel) && cljs.core.seq(yrel)) {
    var ks = clojure.set.intersection.cljs$core$IFn$_invoke$arity$2(cljs.core.set(cljs.core.keys(cljs.core.first(xrel))), cljs.core.set(cljs.core.keys(cljs.core.first(yrel))));
    var vec__24966 = cljs.core.count(xrel) <= cljs.core.count(yrel) ? new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [xrel, yrel], null) : new cljs.core.PersistentVector(null, 2, 5, cljs.core.PersistentVector.EMPTY_NODE, [yrel, xrel], null);
    var r = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24966, 0, null);
    var s = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24966, 1, null);
    var idx = clojure.set.index(r, ks);
    return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret, x) {
      var found = function () {
        var G__24969 = cljs.core.select_keys(x, ks);
        return idx.cljs$core$IFn$_invoke$arity$1 ? idx.cljs$core$IFn$_invoke$arity$1(G__24969) : idx.call(null, G__24969);
      }();

      if (cljs.core.truth_(found)) {
        return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (p1__24960_SHARP_, p2__24961_SHARP_) {
          return cljs.core.conj.cljs$core$IFn$_invoke$arity$2(p1__24960_SHARP_, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([p2__24961_SHARP_, x], 0)));
        }, ret, found);
      } else {
        return ret;
      }
    }, cljs.core.PersistentHashSet.EMPTY, s);
  } else {
    return cljs.core.PersistentHashSet.EMPTY;
  }
};

clojure.set.join.cljs$core$IFn$_invoke$arity$3 = function (xrel, yrel, km) {
  var vec__24970 = cljs.core.count(xrel) <= cljs.core.count(yrel) ? new cljs.core.PersistentVector(null, 3, 5, cljs.core.PersistentVector.EMPTY_NODE, [xrel, yrel, clojure.set.map_invert(km)], null) : new cljs.core.PersistentVector(null, 3, 5, cljs.core.PersistentVector.EMPTY_NODE, [yrel, xrel, km], null);
  var r = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24970, 0, null);
  var s = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24970, 1, null);
  var k = cljs.core.nth.cljs$core$IFn$_invoke$arity$3(vec__24970, 2, null);
  var idx = clojure.set.index(r, cljs.core.vals(k));
  return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (ret, x) {
    var found = function () {
      var G__24973 = clojure.set.rename_keys(cljs.core.select_keys(x, cljs.core.keys(k)), k);
      return idx.cljs$core$IFn$_invoke$arity$1 ? idx.cljs$core$IFn$_invoke$arity$1(G__24973) : idx.call(null, G__24973);
    }();

    if (cljs.core.truth_(found)) {
      return cljs.core.reduce.cljs$core$IFn$_invoke$arity$3(function (p1__24962_SHARP_, p2__24963_SHARP_) {
        return cljs.core.conj.cljs$core$IFn$_invoke$arity$2(p1__24962_SHARP_, cljs.core.merge.cljs$core$IFn$_invoke$arity$variadic(cljs.core.prim_seq.cljs$core$IFn$_invoke$arity$2([p2__24963_SHARP_, x], 0)));
      }, ret, found);
    } else {
      return ret;
    }
  }, cljs.core.PersistentHashSet.EMPTY, s);
};

clojure.set.join.cljs$lang$maxFixedArity = 3;
/**
 * Is set1 a subset of set2?
 */

clojure.set.subset_QMARK_ = function clojure$set$subset_QMARK_(set1, set2) {
  return cljs.core.count(set1) <= cljs.core.count(set2) && cljs.core.every_QMARK_(function (p1__24974_SHARP_) {
    return cljs.core.contains_QMARK_(set2, p1__24974_SHARP_);
  }, set1);
};
/**
 * Is set1 a superset of set2?
 */


clojure.set.superset_QMARK_ = function clojure$set$superset_QMARK_(set1, set2) {
  return cljs.core.count(set1) >= cljs.core.count(set2) && cljs.core.every_QMARK_(function (p1__24975_SHARP_) {
    return cljs.core.contains_QMARK_(set1, p1__24975_SHARP_);
  }, set2);
};

Object.defineProperty(module.exports, "union", {
  enumerable: false,
  get: function get() {
    return clojure.set.union;
  }
});
Object.defineProperty(module.exports, "map_invert", {
  enumerable: false,
  get: function get() {
    return clojure.set.map_invert;
  }
});
Object.defineProperty(module.exports, "join", {
  enumerable: false,
  get: function get() {
    return clojure.set.join;
  }
});
Object.defineProperty(module.exports, "select", {
  enumerable: false,
  get: function get() {
    return clojure.set.select;
  }
});
Object.defineProperty(module.exports, "intersection", {
  enumerable: false,
  get: function get() {
    return clojure.set.intersection;
  }
});
Object.defineProperty(module.exports, "superset_QMARK_", {
  enumerable: false,
  get: function get() {
    return clojure.set.superset_QMARK_;
  }
});
Object.defineProperty(module.exports, "index", {
  enumerable: false,
  get: function get() {
    return clojure.set.index;
  }
});
Object.defineProperty(module.exports, "bubble_max_key", {
  enumerable: false,
  get: function get() {
    return clojure.set.bubble_max_key;
  }
});
Object.defineProperty(module.exports, "subset_QMARK_", {
  enumerable: false,
  get: function get() {
    return clojure.set.subset_QMARK_;
  }
});
Object.defineProperty(module.exports, "rename", {
  enumerable: false,
  get: function get() {
    return clojure.set.rename;
  }
});
Object.defineProperty(module.exports, "rename_keys", {
  enumerable: false,
  get: function get() {
    return clojure.set.rename_keys;
  }
});
Object.defineProperty(module.exports, "project", {
  enumerable: false,
  get: function get() {
    return clojure.set.project;
  }
});
Object.defineProperty(module.exports, "difference", {
  enumerable: false,
  get: function get() {
    return clojure.set.difference;
  }
});